module.exports = __webpack_public_path__ + "img/down_arrow.3273eb71.svg";